import { render, staticRenderFns } from "./ResetDialog.vue?vue&type=template&id=b2147bb4"
import script from "./ResetDialog.vue?vue&type=script&lang=js"
export * from "./ResetDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetDialog.vue?vue&type=style&index=0&id=b2147bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports